import { resolveTimelineTimeZone } from './timeline-timezone';

export function formatTimelineDate(
  dateStr: string,
  precision: string,
  locale?: string,
  timeZone?: string | null
): string {
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;

  const zone = resolveTimelineTimeZone(timeZone);
  const zoneOpt = { timeZone: zone } as const;

  if (precision === 'year') {
    return d.toLocaleDateString(locale, { year: 'numeric', ...zoneOpt });
  }
  if (precision === 'month') {
    return d.toLocaleDateString(locale, { month: 'short', year: 'numeric', ...zoneOpt });
  }
  if (precision === 'hour') {
    return d.toLocaleString(locale, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      timeZoneName: 'short',
      ...zoneOpt,
    });
  }
  if (precision === 'minute' || precision === 'second') {
    return d.toLocaleString(locale, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short',
      ...zoneOpt,
    });
  }
  return d.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    ...zoneOpt,
  });
}

export function formatTimelineItemLabelForBadge(
  item: {
    name: string;
    start_date: string;
    start_precision: string;
    start_timezone?: string | null;
    end_date: string | null;
    end_precision: string | null;
    end_timezone?: string | null;
  },
  locale?: string
): string {
  const dateLine =
    item.end_date && item.end_precision
      ? `${formatTimelineDate(item.start_date, item.start_precision, locale, item.start_timezone)} – ${formatTimelineDate(item.end_date, item.end_precision, locale, item.end_timezone)}`
      : formatTimelineDate(item.start_date, item.start_precision, locale, item.start_timezone);
  return `${dateLine} · ${item.name}`;
}
